__turbopack_context__.v({
  "breadcrumbs": "HghSJG_breadcrumbs",
  "iconWrapper": "HghSJG_iconWrapper",
  "lastItem": "HghSJG_lastItem",
  "link": "HghSJG_link",
  "linkWrapper": "HghSJG_linkWrapper",
  "svg": "HghSJG_svg",
  "truncatedSegment": "HghSJG_truncatedSegment",
});
